<div class="form-content-item partner-api-page">
  <div class="partner-api-header">
    <div class="partner-api-header-content">
      <div class="partner-api-header-icon">
        <mat-icon>vpn_key</mat-icon>
      </div>
      <div>
        <h1>{{ 'partner_api_title' | translate }}</h1>
        <p class="partner-api-header-desc">{{ 'partner_api_subtitle' | translate }}</p>
      </div>
    </div>
  </div>

  <mat-card class="partner-api-card">
    <p>{{ 'partner_api_intro' | translate }}</p>
    <ol class="partner-api-steps">
      <li>{{ 'partner_api_step_create' | translate }}</li>
      <li>{{ 'partner_api_step_copy' | translate }}</li>
      <li>
        {{ 'partner_api_step_call' | translate }}
        <code>Authorization: Bearer {{ 'partner_api_key_placeholder' | translate }}</code>
      </li>
    </ol>
    <p>
      {{ 'personal_access_token_docs_contact' | translate }}
      <a [href]="'mailto:' + contactMail">{{ contactMail }}</a>
    </p>
  </mat-card>

  <app-personal-access-token></app-personal-access-token>

  <p class="partner-api-footer">{{ 'partner_api_account_hint' | translate }}</p>
</div>
